@if (filteredItems$ | async; as filteredAbteilungen) {
  @if ((loading$ | async) === false || (filteredAbteilungen?.length || 0) > 0) {
    <div class="flex flex-col mt-5 pb-5 gap-2 select-none"
      >
      @if (filteredAbteilungen.length < 1) {
        <div class="flex items-center justify-center px-4 py-4 text-center mt-3">
          Die Suche hat keine Treffer ergeben.
        </div>
      } @else {
        @for (abteilung of filteredAbteilungen; track trackByFn($index, abteilung)) {
          <soft-abteilung-card
            [ngClass]="abteilung.selected ? 'opacity-100' : 'opacity-75'"
            mode="selection"
            (tapped)="abteilungTapped(abteilung.abteilung)"
            [abteilung]="abteilung.abteilung"
            [selected]="abteilung.selected">
          </soft-abteilung-card>
        }
      }
    </div>
  } @else {
    <div class="flex flex-col mt-5 pb-5 gap-2">
      <div class="flex soft-card rounded w-full h-20" *softRepeat="5">
        <div class="flex flex-col gap-2.5 items-start pb-1.5 pt-2">
          <div class="h-4 w-20 skeleton rounded"></div>
          <div class="h-4 w-36 skeleton rounded"></div>
        </div>
      </div>
    </div>
  }
}


